import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useReducer, useRef, useState } from "react";
import { Button, Form, FormGroup, Modal, Row } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { getAllCustomerCampaings, getAllCustomerGroups } from "../../store/api/CustomerApi";
import { CheckLg, DashCircle } from "react-bootstrap-icons";
import { addNotice, attachFile, setErrorDialog } from "../../store/api/CommonFunctions";
import { useDispatch } from "react-redux";

const ModalNewNotice = (props) => {
    const dispatch = useDispatch();
    const inputFile = useRef();
    const frmNotice = useRef();
    const [customerGroups, setCustomerGroups] = useState({ Data: [] });
    const [campaings, setCampaigns] = useState({ Data: [] });
    const { setPopData, popData } = props;
    const [currentCat, setCurrentCat] = useState("");
    const { handleSubmit, register, errors } = useForm();
    const { show, customerCode, staffCodes } = popData;
    function close() {
        setCurrentCat("");
        setPopData({
            show: false
        })
    }
    function addNewNotice(data) {
        if (currentCat === "CustomerGroups" || currentCat === "Campaigns") {
            data.NoticeCategory = "Customers"
        }
        const onSuccess = (res) => {
            if (res.Error) {
                setErrorDialog(dispatch, res.Error, "صدور اطلاعیه");
                return;
            }
            if (res.ID) {
                setErrorDialog(dispatch, "success", "صدور اطلاعیه");
            }
            dispatch(attachFile(inputFile.current, res.ID, "Notice", () => frmNotice.current.reset()));
        }
        if (customerCode) {
            data.CustomerCode = customerCode;
        }
        addNotice(data, onSuccess);

    }
    function getCustGroups() {
        if (!customerGroups.Data || customerGroups.Data.length === 0) {
            getAllCustomerGroups(setCustomerGroups);
        }
    }
    function getCustCampaings() {
        if (!campaings.Data || campaings.Data.length === 0) {
            getAllCustomerCampaings(setCampaigns);
        }
    }
    function onCatChange(catName) {
        if (catName === "CustomerGroups") {
            getCustGroups();
        }
        else if (catName === "Campaigns") {
            getCustCampaings();
        }
        setCurrentCat(catName);
    }
    return (
        <Modal show={show} onHide={() => { }}>
            <Modal.Header className="headerStyle">
                <span>&nbsp; صدور اطلاعیه جدید</span>
                <span><FontAwesomeIcon icon={faTimes} size="lg" onClick={close} /></span>
            </Modal.Header>
            <Modal.Body className="bodyStyle">
                <form onSubmit={handleSubmit(addNewNotice)} ref={frmNotice}>
                    <Row>
                        <FormGroup className="mt-0 col-md-6">
                            <label className="blueTitle">دسته بندی اطلاعیه</label><span style={{ color: "red" }}>*</span>
                            {(!customerCode || customerCode.length === 0) &&
                                <select name="NoticeCategory" defaultValue="" className="form-control" ref={register({ required: true })} onChange={e => onCatChange(e.target.value)}>
                                    <option value="">انتخاب کنید</option>
                                    <option value="CustomerGroups">گروه های مشتری</option>
                                    <option value="Campaigns">کمپین های مشتری</option>
                                    {/* <option value="Users">کاربران سیستم</option> */}
                                </select>
                            }
                            {customerCode?.length > 0 &&
                                <select name="NoticeCategory" value="Customers" readOnly className="form-control" ref={register({ required: true })}>
                                    <option value="Customers">مشتریان</option>
                                </select>
                            }
                            {staffCodes?.length > 0 &&
                                <select name="NoticeCategory" value="Staffs" readOnly className="form-control" ref={register({ required: true })}>
                                    <option value="Staffs">تکنسین ها /نمایندگان/پرسنل</option>
                                </select>
                            }
                            {errors?.NoticeCategory && <small className="errors">انتخاب یک دسته بندی الزامی است</small>}
                        </FormGroup>
                        {currentCat === "CustomerGroups" &&
                            <FormGroup className="mt-0  col-md-6">
                                <label className="blueTitle">گروه مشتری</label><span style={{ color: "red" }}>*</span>
                                <select name="CustomerGroupID" defaultValue="" className="form-control" ref={register({ required: true })}>
                                    <option value="">انتخاب کنید</option>
                                    {customerGroups?.Data && Array.isArray(customerGroups.Data) &&
                                        customerGroups.Data.map((grp, i) => <option key={i} value={grp.Value}>{grp.Key}</option>)
                                    }
                                </select>
                                {errors?.CustomerGroupID && <small className="errors">انتخاب گروه مشتری الزامی است</small>}
                            </FormGroup>
                        }
                        {currentCat === "Campaigns" &&
                            <FormGroup className="mt-0  col-md-6">
                                <label className="blueTitle">کمپین مشتری</label><span style={{ color: "red" }}>*</span>
                                <select name="CampaignID" defaultValue="" className="form-control" ref={register({ required: true })}>
                                    <option value="">انتخاب کنید</option>
                                    {campaings?.Data && Array.isArray(campaings.Data) &&
                                        campaings.Data.map((cmp, i) => <option key={i} value={cmp.Value}>{cmp.Key}</option>)}
                                </select>
                                {errors?.CampaignID && <small className="errors">انتخاب کمپین مشتری الزامی است</small>}
                            </FormGroup>
                        }
                        {currentCat === "Users" &&
                            <FormGroup className="mt-0  col-md-6">
                                <label className="blueTitle">کاربران سیستم</label><span style={{ color: "red" }}>*</span>
                                <select name="Users" defaultValue="" className="form-control" ref={register({ required: true })}>
                                    <option value="">انتخاب کنید</option>
                                </select>
                                {errors?.Users && <small className="errors">انتخاب کاربر  الزامی است</small>}
                            </FormGroup>
                        }
                    </Row>
                    <FormGroup>
                        <label className="blueTitle">موضوع اطلاعیه</label><span style={{ color: "red" }}>*</span>
                        <Form.Control name="NoticeSubject" ref={register({ required: true })} />
                        {errors?.NoticeSubject && <small className="errors">موضوع اطلاعیه کاربر  الزامی است</small>}
                    </FormGroup>
                    <FormGroup>
                        <label className="blueTitle">شرح اطلاعیه</label><span style={{ color: "red" }}>*</span>
                        <Form.Control as="textarea" name="NoticeDesc" ref={register({ required: true })} maxLength={550} />
                        {errors?.NoticeDesc && <small className="errors">شرح اطلاعیه کاربر  الزامی است</small>}
                    </FormGroup>
                    <FormGroup>
                        <label className="blueTitle">پیوست</label>
                        <input ref={inputFile} type="file" className="form-control" />
                    </FormGroup>
                    <FormGroup>
                        <input type="checkbox" className="form-check-input" name="SendSMS" ref={register({})} />&nbsp;<span style={{ color: "blue" }}> پیامک ارسال شود</span>
                    </FormGroup>
                    <div className="mt-2">
                        <Button type="submit" variant="info" className="group-Btn"><CheckLg />&nbsp; صدور اطلاعیه</Button>
                        <Button variant="danger" onClick={close} className="group-Btn"><DashCircle size={15} />&nbsp; انصراف</Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}
export default ModalNewNotice;